export enum ConditionType {
  excellent = 'excellent',
  good = 'good',
  fair = 'fair',
  poor = 'poor',
}

export const ConditionTypeValues: { [key in ConditionType]: string } = {
  excellent: 'Excellent',
  good: 'Good',
  fair: 'Fair',
  poor: 'Poor',
};

export const fromConditionTypeValue = (value: string) => {
  switch (value) {
    case 'Excellent':
      return ConditionType.excellent;
    case 'Good':
      return ConditionType.good;
    case 'Fair':
      return ConditionType.fair;
    case 'Poor':
      return ConditionType.poor;
    default:
      throw new Error(`invalid ColorType value: ${value}`);
  }
};
